import React from 'react';

import cx from 'classnames';

import RenderInDomNode from 'components/Pages/Admin/Page/common/RenderInStuff';
import Button from 'components/shared/Button';
import Text from 'components/shared/Typography/Text';
import { ASSET_SIZE_TYPES, getAssetSrcFromId } from 'utils/asset';

import CheckBox from './Checkbox';
import { useGallery } from './functions';
import s from './index.module.css';
import { IGalleryBlockProps, IImageBlockProps } from './types';

function GalleryBlock(props: IGalleryBlockProps) {
  const { data: blockData } = props;
  const contentProps = useGallery(props);

  return <GalleryBlockContent {...contentProps} blockData={blockData} />;
}

export function GalleryBlockContent(
  //@ts-ignore
  { isAllChecked, handleCheckAll, checkedIds, handleDownload, blockData, handleCheckId },
) {
  return (
    <div className={cx(s.container, 'custom-gallery')}>
      {/*@ts-ignore*/}
      <RenderInDomNode id="gallery">
        <div className={cx(s.selectAllBlock, 'custom-gallery-selectall')}>
          <CheckBox
            className={cx(s.marginRight, 'custom-gallery-checkbox')}
            checked={isAllChecked}
            onClick={handleCheckAll}
          >
            <Text className={cx(s.text, 'custom-gallery-text')} data-block>
              Select all
            </Text>
          </CheckBox>
          <Button
            size="extraSmall"
            disabled={!checkedIds.length}
            onClick={handleDownload}
            data-block
            className="custom-gallery-button"
          >
            Download Images
          </Button>
        </div>
      </RenderInDomNode>
      <div className={cx(s.imagesContainer, 'custom-gallery-images')}>
        {blockData.data.photos.map((id: string) => (
          <ImageBlock onCheck={() => handleCheckId(id)} key={id} imgId={id} checked={checkedIds.includes(id)} />
        ))}
      </div>
    </div>
  );
}

export default GalleryBlock;

function ImageBlock({ checked, imgId, onCheck }: IImageBlockProps) {
  return (
    <div className={cx(s.imageBlock, 'custom-gallery-image')} onClick={onCheck}>
      <img src={getAssetSrcFromId(imgId, ASSET_SIZE_TYPES.MEDIUM)} alt="" />
      <div className={cx(s.checkCover, 'custom-gallery-image-checkcover')}>
        <CheckBox className={cx(s.checkBox, 'custom-gallery-image-checkbox')} checked={checked} />
      </div>
    </div>
  );
}
